import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type FormsV2SharedQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.DosageFormatSort> | Types.DosageFormatSort>;
}>;


export type FormsV2SharedQuery = { viewer: { __typename: 'Viewer', formsV2: Array<{ __typename: 'BaseFormat', id: string, baseFormatName: string }> | null } | null };


export const FormsV2SharedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormsV2_Shared_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DosageFormatSort"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baseFormatName"}}]}}]}}]}}]} as unknown as DocumentNode;
export type FormsV2SharedQueryQueryResult = Apollo.QueryResult<FormsV2SharedQuery, FormsV2SharedQueryVariables>;

export function useFormsV2SharedQuery(baseOptions?: Apollo.QueryHookOptions<FormsV2SharedQuery, FormsV2SharedQueryVariables>) {
  return Apollo.useQuery<FormsV2SharedQuery, FormsV2SharedQueryVariables>(
    FormsV2SharedQueryDocument,
    baseOptions
  );
}

export function useFormsV2SharedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormsV2SharedQuery, FormsV2SharedQueryVariables>) {
  return Apollo.useLazyQuery<FormsV2SharedQuery, FormsV2SharedQueryVariables>(
    FormsV2SharedQueryDocument,
    baseOptions
  );
}

export function useFormsV2SharedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FormsV2SharedQuery, FormsV2SharedQueryVariables>) {
  return Apollo.useSuspenseQuery<FormsV2SharedQuery, FormsV2SharedQueryVariables>(
    FormsV2SharedQueryDocument,
    baseOptions
  );
}
